module.exports = __webpack_public_path__ + "static/media/daily-brief.1b84fc6d.jpg";